
function Transition () {
  if (new.target !== Transition) {
    throw new TypeError('Cannot call a class as a function')
  }
}

Transition.CLASS_NAME = 'collapse-transition'

Transition.prototype.beforeEnter = function (el) {
  el.classList.add(Transition.CLASS_NAME)

  el.style.height = 0
}

Transition.prototype.enter = function (el) {
  if (el.scrollHeight !== 0) {
    el.style.height = el.scrollHeight + 'px'
  } else {
    el.style.height = 0
  }
}

Transition.prototype.afterEnter = function (el) {
  el.classList.remove(Transition.CLASS_NAME)

  el.style.height = ''
}

Transition.prototype.beforeLeave = function (el) {
  el.classList.add(Transition.CLASS_NAME)

  el.style.height = el.scrollHeight + 'px'
}

Transition.prototype.leave = function (el) {
  if (el.scrollHeight !== 0) {
    el.style.height = 0
  }
}

Transition.prototype.afterLeave = function (el) {
  el.classList.remove(Transition.CLASS_NAME)

  el.style.height = ''
}

export default Transition



// WEBPACK FOOTER //
// ./src/style/TransitionFunction.js